import { Dialog } from "primereact/dialog";
import { Link } from "react-router-dom";
import { IoPhonePortraitOutline, IoClose } from "react-icons/io5";
import { IoLogoGooglePlaystore } from "react-icons/io5";
import { FaAppStore, FaDesktop } from "react-icons/fa";
import { SiHuawei } from "react-icons/si";
import { BsWindows } from "react-icons/bs";

const mobileAppLinks = [
	{
		name: "Google Play",
		icon: <IoLogoGooglePlaystore size={20} />,
		url: "https://play.google.com/store/apps/details?id=com.akellolibrary",
		description: "Android",
	},
	{
		name: "App Store",
		icon: <FaAppStore size={20} />,
		url: "https://apps.apple.com/zw/app/akello-library/id6451323375",
		description: "iOS",
	},
	{
		name: "Huawei",
		icon: <SiHuawei size={20} />,
		url: "https://appgallery.huawei.com/app/C108363007",
		description: "Huawei",
	},
];

const desktopAppLink = {
	name: "Windows",
	icon: <BsWindows size={20} />,
	url:
		process.env.REACT_APP_WINDOWS_APP_LINK ||
		"https://library.akello.co/akello-windowsx64-installation-file.zip",
	description: "Windows 10/11",
};

const ReadOnAppModal = ({ visible, onClose, bookTitle, onViewDetails }) => {
	return (
		<Dialog
			visible={visible}
			onHide={onClose}
			header={null}
			showHeader={false}
			className="w-full max-w-md mx-4"
			contentClassName="p-0"
			dismissableMask={true}
		>
			<div className="p-6 relative">
				{/* Close Button */}
				<button
					type="button"
					onClick={onClose}
					className="absolute top-2 right-2 p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors duration-200"
					aria-label="Close modal"
				>
					<IoClose size={24} />
				</button>

				{/* Header Icon */}
				<div className="flex justify-center mb-4">
					<div className="p-4 bg-green-50 rounded-full">
						<IoPhonePortraitOutline size={48} className="text-akgreener" />
					</div>
				</div>

				{/* Title & Message */}

				<div className="text-center mb-6">
					<h3 className="text-xl font-bold text-gray-900 mb-2">Ready to Read?</h3>
					{bookTitle && <p className="text-sm text-gray-500 mb-2 italic">"{bookTitle}"</p>}
					<p className="text-gray-600">
						Download the reader app to start reading your books!
					</p>
				</div>

				{/* Mobile Apps Section */}
				<div className="mb-4">
					<p className="text-xs font-medium text-gray-500 uppercase mb-2 flex items-center gap-2">
						<IoPhonePortraitOutline size={14} />
						Read on Mobile
					</p>
					<div className="grid grid-cols-3 gap-2">
						{mobileAppLinks.map((link) => (
							<a
								key={link.name}
								href={link.url}
								target="_blank"
								rel="noreferrer noopener"
								className="flex flex-col items-center p-3 rounded-lg bg-gray-50 hover:bg-green-50 border border-gray-200 hover:border-akgreener transition-all duration-200 group"
							>
								<span className="text-gray-600 group-hover:text-akgreener mb-1">{link.icon}</span>
								<span className="text-xs font-medium text-gray-700 group-hover:text-akgreener">
									{link.name}
								</span>
							</a>
						))}
					</div>
				</div>

				{/* Desktop App Section */}
				<div className="mb-6">
					<p className="text-xs font-medium text-gray-500 uppercase mb-2 flex items-center gap-2">
						<FaDesktop size={14} />
						Read on Desktop
					</p>
					<a
						href={desktopAppLink.url}
						target="_blank"
						rel="noreferrer noopener"
						className="flex items-center justify-center gap-3 p-3 rounded-lg bg-gray-50 hover:bg-purple-50 border border-gray-200 hover:border-purple-400 transition-all duration-200 group"
					>
						<span className="text-gray-600 group-hover:text-purple-600">{desktopAppLink.icon}</span>
						<span className="text-sm font-medium text-gray-700 group-hover:text-purple-600">
							Download for {desktopAppLink.description}
						</span>
					</a>
				</div>

				{/* Action Buttons */}
				<div className="flex flex-col gap-2">
					<Link
						to="/downloads"
						className="w-full py-2.5 px-4 bg-akgreener text-white rounded-lg font-medium text-center hover:bg-akgreener/90 transition-colors duration-200"
						onClick={onClose}
					>
						View All Download Options
					</Link>

					{onViewDetails && (
						<button
							type="button"
							onClick={onViewDetails}
							className="w-full py-2.5 px-4 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors duration-200"
						>
							View Book Details
						</button>
					)}

					<button
						type="button"
						onClick={onClose}
						className="w-full py-2 px-4 text-gray-500 text-sm hover:text-gray-700 transition-colors duration-200"
					>
						Got it
					</button>
				</div>
			</div>
		</Dialog>
	);
};

export default ReadOnAppModal;
